import './tailwind.css';
import { initHeaderScroll } from './header-scroll';
import { initMobileNav } from './mobile-nav';

// biome-ignore lint/suspicious/noExplicitAny: island mount functions accept varying prop shapes; each island casts internally
const islands: Record<string, () => Promise<{ default: (el: HTMLElement, props: any) => void }>> = {
  'posts-slider': () => import('./islands/posts-slider'),
  'team-slider': () => import('./islands/team-slider'),
  'testimonials-slider': () => import('./islands/testimonials-slider'),
  'cta-pair': () => import('./islands/cta-pair'),
  reveal: () => import('./islands/reveal'),
  'parallax-media': () => import('./islands/parallax-media'),
  'office-map': () => import('./islands/office-map'),
  'property-gallery': () => import('./islands/property-gallery'),
};

document.querySelectorAll<HTMLElement>('[data-island]').forEach(async (el) => {
  const name = el.dataset.island;
  if (!name || !islands[name]) return;
  const props = el.dataset.props ? JSON.parse(el.dataset.props) : {};
  const { default: mount } = await islands[name]();
  mount(el, props);
});

initMobileNav();
initHeaderScroll();
